module.exports = __webpack_public_path__ + "static/media/firulete5.3edd1198.png";